




















import { Vue, Component, Prop } from "vue-property-decorator";
import TooltipIcon from "@share/common/TooltipIcon.vue";

@Component({components: {TooltipIcon}})

export default class FormGroup extends Vue {
    @Prop({ default: "" }) title: string;
    @Prop({ default: false }) isRequired: boolean;
    @Prop() tooltipText: string | undefined;
    @Prop({ default: false }) grayTitle: boolean;

    get tooltipProps() {
        return this.tooltipText ? {
            title: this.tooltipText
        } : null;
    }
}

